/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PlatformApiResultOfListOfNavigationItemDto } from '../models/platform-api-result-of-list-of-navigation-item-dto';
import { PlatformApiResultOfNavigationItemDto } from '../models/platform-api-result-of-navigation-item-dto';
import { deleteNavigationitemsId } from '../fn/navigation-item/delete-navigationitems-id';
import { DeleteNavigationitemsId$Params } from '../fn/navigation-item/delete-navigationitems-id';
import { postNavigationitems } from '../fn/navigation-item/post-navigationitems';
import { PostNavigationitems$Params } from '../fn/navigation-item/post-navigationitems';
import { postNavigationitemsActionChangeconfiguration } from '../fn/navigation-item/post-navigationitems-action-changeconfiguration';
import { PostNavigationitemsActionChangeconfiguration$Params } from '../fn/navigation-item/post-navigationitems-action-changeconfiguration';
import { postNavigationitemsActionChangename } from '../fn/navigation-item/post-navigationitems-action-changename';
import { PostNavigationitemsActionChangename$Params } from '../fn/navigation-item/post-navigationitems-action-changename';
import { postNavigationitemsActionCreatemenuitem } from '../fn/navigation-item/post-navigationitems-action-createmenuitem';
import { PostNavigationitemsActionCreatemenuitem$Params } from '../fn/navigation-item/post-navigationitems-action-createmenuitem';
import { postNavigationitemsActionMovemenuitem } from '../fn/navigation-item/post-navigationitems-action-movemenuitem';
import { PostNavigationitemsActionMovemenuitem$Params } from '../fn/navigation-item/post-navigationitems-action-movemenuitem';
import { postNavigationitemsActionReorder } from '../fn/navigation-item/post-navigationitems-action-reorder';
import { PostNavigationitemsActionReorder$Params } from '../fn/navigation-item/post-navigationitems-action-reorder';

@Injectable({ providedIn: 'root' })
export class PlatformNavigationItemService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postNavigationitems()` */
  static readonly PostNavigationitemsPath = '/api/navigationitems';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postNavigationitems()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postNavigationitems$Response(params: PostNavigationitems$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfNavigationItemDto>> {
    return postNavigationitems(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postNavigationitems$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postNavigationitems(params: PostNavigationitems$Params, context?: HttpContext): Observable<PlatformApiResultOfNavigationItemDto> {
    return this.postNavigationitems$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfNavigationItemDto>): PlatformApiResultOfNavigationItemDto => r.body)
    );
  }

  /** Path part for operation `postNavigationitemsActionCreatemenuitem()` */
  static readonly PostNavigationitemsActionCreatemenuitemPath = '/api/navigationitems/action/createmenuitem';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postNavigationitemsActionCreatemenuitem()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postNavigationitemsActionCreatemenuitem$Response(params: PostNavigationitemsActionCreatemenuitem$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfNavigationItemDto>> {
    return postNavigationitemsActionCreatemenuitem(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postNavigationitemsActionCreatemenuitem$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postNavigationitemsActionCreatemenuitem(params: PostNavigationitemsActionCreatemenuitem$Params, context?: HttpContext): Observable<PlatformApiResultOfNavigationItemDto> {
    return this.postNavigationitemsActionCreatemenuitem$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfNavigationItemDto>): PlatformApiResultOfNavigationItemDto => r.body)
    );
  }

  /** Path part for operation `postNavigationitemsActionMovemenuitem()` */
  static readonly PostNavigationitemsActionMovemenuitemPath = '/api/navigationitems/action/movemenuitem';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postNavigationitemsActionMovemenuitem()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postNavigationitemsActionMovemenuitem$Response(params: PostNavigationitemsActionMovemenuitem$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfNavigationItemDto>> {
    return postNavigationitemsActionMovemenuitem(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postNavigationitemsActionMovemenuitem$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postNavigationitemsActionMovemenuitem(params: PostNavigationitemsActionMovemenuitem$Params, context?: HttpContext): Observable<PlatformApiResultOfNavigationItemDto> {
    return this.postNavigationitemsActionMovemenuitem$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfNavigationItemDto>): PlatformApiResultOfNavigationItemDto => r.body)
    );
  }

  /** Path part for operation `deleteNavigationitemsId()` */
  static readonly DeleteNavigationitemsIdPath = '/api/navigationitems/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteNavigationitemsId()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteNavigationitemsId$Response(params: DeleteNavigationitemsId$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfNavigationItemDto>> {
    return deleteNavigationitemsId(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteNavigationitemsId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteNavigationitemsId(params: DeleteNavigationitemsId$Params, context?: HttpContext): Observable<PlatformApiResultOfNavigationItemDto> {
    return this.deleteNavigationitemsId$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfNavigationItemDto>): PlatformApiResultOfNavigationItemDto => r.body)
    );
  }

  /** Path part for operation `postNavigationitemsActionReorder()` */
  static readonly PostNavigationitemsActionReorderPath = '/api/navigationitems/action/reorder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postNavigationitemsActionReorder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postNavigationitemsActionReorder$Response(params: PostNavigationitemsActionReorder$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfListOfNavigationItemDto>> {
    return postNavigationitemsActionReorder(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postNavigationitemsActionReorder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postNavigationitemsActionReorder(params: PostNavigationitemsActionReorder$Params, context?: HttpContext): Observable<PlatformApiResultOfListOfNavigationItemDto> {
    return this.postNavigationitemsActionReorder$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfListOfNavigationItemDto>): PlatformApiResultOfListOfNavigationItemDto => r.body)
    );
  }

  /** Path part for operation `postNavigationitemsActionChangename()` */
  static readonly PostNavigationitemsActionChangenamePath = '/api/navigationitems/action/changename';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postNavigationitemsActionChangename()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postNavigationitemsActionChangename$Response(params: PostNavigationitemsActionChangename$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfNavigationItemDto>> {
    return postNavigationitemsActionChangename(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postNavigationitemsActionChangename$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postNavigationitemsActionChangename(params: PostNavigationitemsActionChangename$Params, context?: HttpContext): Observable<PlatformApiResultOfNavigationItemDto> {
    return this.postNavigationitemsActionChangename$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfNavigationItemDto>): PlatformApiResultOfNavigationItemDto => r.body)
    );
  }

  /** Path part for operation `postNavigationitemsActionChangeconfiguration()` */
  static readonly PostNavigationitemsActionChangeconfigurationPath = '/api/navigationitems/action/changeconfiguration';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postNavigationitemsActionChangeconfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postNavigationitemsActionChangeconfiguration$Response(params: PostNavigationitemsActionChangeconfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfNavigationItemDto>> {
    return postNavigationitemsActionChangeconfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postNavigationitemsActionChangeconfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postNavigationitemsActionChangeconfiguration(params: PostNavigationitemsActionChangeconfiguration$Params, context?: HttpContext): Observable<PlatformApiResultOfNavigationItemDto> {
    return this.postNavigationitemsActionChangeconfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfNavigationItemDto>): PlatformApiResultOfNavigationItemDto => r.body)
    );
  }

}
